module.exports = __webpack_public_path__ + "img/icon-slider-01-academy-template.33e403b8.svg";